import React from 'react';
import ContentLoader from 'react-content-loader';

export const MapLoader = () => {
  return (
    <ContentLoader
      width="100%"
      height="100%"
      viewBox="0 0 568 330"
      preserveAspectRatio="none"
      backgroundColor="#f0f0f0"
      foregroundColor="#dedede"
    >
      <rect x="0" y="0" rx="2" ry="2" width="568" height="330" />
    </ContentLoader>
  );
};

export default MapLoader;
